import React from 'react';
import Button from 'react-bootstrap/Button';
import { API } from '../constants';
import { getCurrentLangCode } from '../utils/language';

function getUploadText(texts, key, fallback) {
    const v = texts && texts[key];
    if (v === undefined || v === null || v === '') return fallback;
    return String(v).trim();
}

function UploadButton({ filesToUpload, selectedBank, setFiles, setFileValidStatus, setCurrentStep, setOrderbookID, setOrderBooks, isGerman = false, agreementAccepted = false, uiTexts = {} }) {
    let inValidfiles = []
    const isPolish = getCurrentLangCode() === 'pl';
    const handleUpload = async () => {
        if (!agreementAccepted) {
            alert(getUploadText(uiTexts, 'upload.alert.accept_terms', isPolish ? 'Proszę zaakceptować warunki przed kontynuacją.' : (isGerman ? 'Bitte akzeptieren Sie die Bedingungen, bevor Sie fortfahren.' : 'Please accept the terms before proceeding.')));
            return;
        }
        if (filesToUpload.length === 0) {
            alert(getUploadText(uiTexts, 'upload.alert.select_files', isPolish ? 'Najpierw wybierz pliki.' : (isGerman ? 'Bitte wählen Sie zuerst Dateien aus.' : 'Please select files first.')));
            return;
        }
        const hasDuplicate = filesToUpload.some(
            (file) => file.valid === false && file.duplicate === true
        );

        if (hasDuplicate) {
            alert(getUploadText(uiTexts, 'upload.alert.remove_duplicates', isPolish
              ? "Usuń duplikaty (Not valid) w strefie przesyłania."
              : (isGerman
                ? "Bitte entfernen Sie Duplikate (Not valid) in der Dropzone"
                : "Please remove duplicates (Not valid) in the dropzone.")
            ));
            return;
        }
        try {
            const uploadPromises = filesToUpload.map(async (fileObj) => {
                const formData = new FormData();
                formData.append("file", fileObj.file);
                formData.append("bank_name", selectedBank);
                const response = await fetch(`${API}/files/`, {
                    method: "POST",
                    body: formData,
                });

                if (!response.ok) {
                    fileObj.status = response.status;
                    fileObj.statusText = response.statusText;
                    fileObj.valid = false;
                    fileObj.checked = true;
                    inValidfiles.push(fileObj);
                    return { success: false, error: new Error(`File upload failed for ${fileObj.name}`), fileObj };
                }
                const data = await response.json();
                const rows = Array.isArray(data) ? data : [data];
                return { success: true, data: rows, fileObj };
            });

            const results = await Promise.all(uploadPromises);
            const successfulUploads = results.filter((result) => result.success);
            const failedUploads = results.filter((result) => !result.success);

            const mergedRows = successfulUploads
                .flatMap((result) => (Array.isArray(result.data) ? result.data : []));
            if (mergedRows.length > 0) {
                setOrderbookID(mergedRows.map((obj) => obj.id));
                setOrderBooks(mergedRows);
            }

            if (failedUploads.length > 0) {
                setCurrentStep({ activeStep: 0, status: "invalid" });
                console.log(failedUploads);

                if (failedUploads.some((result) => result.fileObj.status === 429)) {
                    alert(isGerman
                      ? "Zu viele Upload-Versuche. Bitte versuchen Sie es später erneut."
                      : "Too many upload attempts. Please try again later."
                    );   
                }
                else {
                    alert(getUploadText(uiTexts, 'upload.alert.bank_mismatch', isPolish
                        ? "Przesłany plik nie pasuje do wybranej instytucji finansowej.\nProszę wybrać poprawny plik."
                        : (isGerman
                          ? "Die hochgeladene Datei stimmt nicht mit der entsprechenden Bank,\n bitte wählen Sie die gültige Datei"
                          : "The uploaded file does not match the selected Financial Institution.\nPlease choose the correct file.")
                      ));
                }
                setFiles(inValidfiles.length > 0 ? inValidfiles : failedUploads.map((r) => r.fileObj).filter(Boolean));
            } else {
                const allRows = successfulUploads.flatMap((r) => r.data);
                setOrderbookID(allRows.map((obj) => obj.id));
                setOrderBooks(allRows);
                setFileValidStatus(true);
                setCurrentStep({ activeStep: 1, status: "valid" });
                setFiles([]); // Clear the dropzone after successful uploads
            }
        } catch (error) {
            setCurrentStep({ activeStep: 0, status: "invalid" });
            console.error("Upload error:", error.message);
        }
    };

    return (
        <div className="d-flex justify-content-end mt-3">
            <Button
                variant="outline-primary"
                className="btn-sm fs-6"
                style={{
                    display: 'inline-flex', width: '100px', alignItems: 'center'
                }}
                onClick={handleUpload}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fillRule="currentColor" className="size-6">
                    <path fillRule="evenodd" d="M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z" clipRule="evenodd" />
                </svg>
                <span>{getUploadText(uiTexts, 'upload.button.next', isPolish ? 'Dalej' : (isGerman ? 'Weiter' : 'Next'))}</span>
            </Button>
        </div>
    );
}
export default UploadButton;